import { IconWrapper } from '../runtime';
export default IconWrapper('ks-contract-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("g", [h("g", {
    "attrs": {
      "filter": 'url(#' + props.id + '9bc30c48' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '44be70f6' + ')'
    }
  })]), h("g", [h("path", {
    "attrs": {
      "opacity": "0.6",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.5837 17.7042C15.6095 18.2208 13.1738 17.9717 10.5291 17.0091C7.89213 16.0494 5.87034 14.6798 5.4478 13.6588C5.24338 13.7672 5.1033 13.9093 5.03914 14.0855C4.66921 15.1019 6.96317 16.8699 10.1628 18.0345C13.3625 19.1991 16.2562 19.3192 16.6262 18.3029C16.6912 18.1241 16.6739 17.9221 16.5837 17.7042Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.8205 4.68006C16.3639 5.2418 17.1596 6.94834 16.5979 8.49171C16.3531 9.16421 15.891 9.69477 15.3197 10.0329C15.3054 10.0416 15.2907 10.0507 15.2757 10.0602L15.2297 10.0898L15.1819 10.1218L15.1325 10.1558L15.0818 10.192L15.0299 10.2301C14.9949 10.2561 14.9593 10.2833 14.9234 10.3116L14.8692 10.3548C14.8496 10.3707 14.8299 10.3869 14.8102 10.4033L14.7511 10.4534C14.4359 10.7246 14.1276 11.0578 14.0093 11.3546L13.9995 11.3802L13.7747 11.9985C13.6081 12.4803 13.7585 12.8615 14.0473 13.1657L14.0788 13.198L14.1113 13.2297C14.1442 13.2612 14.1787 13.2917 14.2143 13.3215L14.2503 13.3509C14.2564 13.3558 14.2625 13.3606 14.2686 13.3654L14.3058 13.394C14.312 13.3988 14.3183 13.4035 14.3246 13.4081L14.3628 13.436L14.4016 13.4632L14.4609 13.5032L14.501 13.5292L14.5416 13.5546L14.5826 13.5796L14.6239 13.6041L14.6656 13.628L14.7196 13.658L14.8262 13.7181C14.8604 13.7376 14.8944 13.7571 14.928 13.7766L15.0281 13.8353C15.0446 13.8451 15.0611 13.8549 15.0775 13.8647L15.175 13.9237C15.3038 14.0024 15.428 14.0814 15.5471 14.1607L15.6356 14.2201C15.7085 14.2696 15.7794 14.3192 15.8483 14.3687L15.9299 14.4282L16.0096 14.4875C16.9797 15.2196 17.4878 15.9365 17.2985 16.4565C16.9286 17.4729 14.0349 17.3527 10.8352 16.1882C7.63554 15.0236 5.34157 13.2556 5.7115 12.2392C5.82557 11.9258 6.17961 11.7204 6.70859 11.6205L6.76699 11.61C6.77684 11.6083 6.78674 11.6067 6.7967 11.6051L6.85715 11.5958C6.86734 11.5943 6.87758 11.5929 6.88788 11.5915L6.95032 11.5835C7.00292 11.5772 7.05687 11.5718 7.11215 11.5672L7.17911 11.5621C7.19038 11.5614 7.2017 11.5606 7.21306 11.5599L7.28189 11.5561C7.30504 11.5549 7.32839 11.5539 7.35194 11.5531L7.42318 11.5509L7.49561 11.5496C7.50778 11.5494 7.52 11.5493 7.53226 11.5492L7.60643 11.5491L7.68173 11.5498C7.69437 11.55 7.70706 11.5502 7.7198 11.5505L7.79676 11.5524C7.80968 11.5528 7.82265 11.5533 7.83566 11.5537L7.91425 11.5569C7.92743 11.5575 7.94067 11.5582 7.95394 11.5588L8.03411 11.5633L8.12982 11.5695C8.16195 11.5718 8.19432 11.5743 8.22692 11.5769L8.32539 11.5854C8.35844 11.5885 8.39171 11.5917 8.4252 11.5951L8.52631 11.6059C8.57719 11.6116 8.62855 11.6177 8.68037 11.6242L8.78461 11.6379C8.81957 11.6426 8.85472 11.6475 8.89006 11.6526L8.99668 11.6685C9.03241 11.674 9.06833 11.6797 9.10444 11.6855L9.15071 11.6932C9.15173 11.6929 9.15283 11.6928 9.15402 11.6931L9.19065 11.6998L9.21479 11.7041L9.26316 11.712L9.31158 11.7191L9.36003 11.7253L9.40848 11.7307L9.45689 11.7353C9.4972 11.7387 9.53742 11.7411 9.57748 11.7425L9.62546 11.7437L9.64937 11.7439L9.69704 11.7436C9.72873 11.743 9.76026 11.7417 9.79157 11.7396L9.83836 11.736C9.8539 11.7346 9.86938 11.733 9.8848 11.7312L9.93084 11.7252C10.3586 11.664 10.73 11.4443 10.9159 10.9581L11.1412 10.34C11.2603 10.0127 11.2267 9.49345 11.145 9.04717L11.1317 8.97735C11.1272 8.95431 11.1225 8.9315 11.1177 8.90898L11.1031 8.84228L11.0956 8.80963L11.0802 8.74588C11.0725 8.71455 11.0645 8.68406 11.0565 8.65456L11.0404 8.59688L11.024 8.54204C11.0159 8.51537 11.0077 8.48984 10.9995 8.4656C10.7771 7.83795 10.7633 7.13212 11.0089 6.45746C11.5706 4.91409 13.2771 4.11832 14.8205 4.68006Z",
      "fill": "white"
    }
  }), h("mask", {
    "attrs": {
      "id": props.id + '05f87d2b',
      "maskUnits": "userSpaceOnUse",
      "x": "5",
      "y": "4",
      "width": "13",
      "height": "14"
    },
    "style": {
      maskType: 'alpha'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.8205 4.68006C16.3639 5.2418 17.1596 6.94834 16.5979 8.49171C16.3531 9.16421 15.891 9.69477 15.3197 10.0329C15.3054 10.0416 15.2907 10.0507 15.2757 10.0602L15.2297 10.0898L15.1819 10.1218L15.1325 10.1558L15.0818 10.192L15.0299 10.2301C14.9949 10.2561 14.9593 10.2833 14.9234 10.3116L14.8692 10.3548C14.8496 10.3707 14.8299 10.3869 14.8102 10.4033L14.7511 10.4534C14.4359 10.7246 14.1276 11.0578 14.0093 11.3546L13.9995 11.3802L13.7747 11.9985C13.6081 12.4803 13.7585 12.8615 14.0473 13.1657L14.0788 13.198L14.1113 13.2297C14.1442 13.2612 14.1787 13.2917 14.2143 13.3215L14.2503 13.3509C14.2564 13.3558 14.2625 13.3606 14.2686 13.3654L14.3058 13.394C14.312 13.3988 14.3183 13.4035 14.3246 13.4081L14.3628 13.436L14.4016 13.4632L14.4609 13.5032L14.501 13.5292L14.5416 13.5546L14.5826 13.5796L14.6239 13.6041L14.6656 13.628L14.7196 13.658L14.8262 13.7181C14.8604 13.7376 14.8944 13.7571 14.928 13.7766L15.0281 13.8353C15.0446 13.8451 15.0611 13.8549 15.0775 13.8647L15.175 13.9237C15.3038 14.0024 15.428 14.0814 15.5471 14.1607L15.6356 14.2201C15.7085 14.2696 15.7794 14.3192 15.8483 14.3687L15.9299 14.4282L16.0096 14.4875C16.9797 15.2196 17.4878 15.9365 17.2985 16.4565C16.9286 17.4729 14.0349 17.3527 10.8352 16.1882C7.63554 15.0236 5.34157 13.2556 5.7115 12.2392C5.82557 11.9258 6.17961 11.7204 6.70859 11.6205L6.76699 11.61C6.77684 11.6083 6.78674 11.6067 6.7967 11.6051L6.85715 11.5958C6.86734 11.5943 6.87758 11.5929 6.88788 11.5915L6.95032 11.5835C7.00292 11.5772 7.05687 11.5718 7.11215 11.5672L7.17911 11.5621C7.19038 11.5614 7.2017 11.5606 7.21306 11.5599L7.28189 11.5561C7.30504 11.5549 7.32839 11.5539 7.35194 11.5531L7.42318 11.5509L7.49561 11.5496C7.50778 11.5494 7.52 11.5493 7.53226 11.5492L7.60643 11.5491L7.68173 11.5498C7.69437 11.55 7.70706 11.5502 7.7198 11.5505L7.79676 11.5524C7.80968 11.5528 7.82265 11.5533 7.83566 11.5537L7.91425 11.5569C7.92743 11.5575 7.94067 11.5582 7.95394 11.5588L8.03411 11.5633L8.12982 11.5695C8.16195 11.5718 8.19432 11.5743 8.22692 11.5769L8.32539 11.5854C8.35844 11.5885 8.39171 11.5917 8.4252 11.5951L8.52631 11.6059C8.57719 11.6116 8.62855 11.6177 8.68037 11.6242L8.78461 11.6379C8.81957 11.6426 8.85472 11.6475 8.89006 11.6526L8.99668 11.6685C9.03241 11.674 9.06833 11.6797 9.10444 11.6855L9.15071 11.6932C9.15173 11.6929 9.15283 11.6928 9.15402 11.6931L9.19065 11.6998L9.21479 11.7041L9.26316 11.712L9.31158 11.7191L9.36003 11.7253L9.40848 11.7307L9.45689 11.7353C9.4972 11.7387 9.53742 11.7411 9.57748 11.7425L9.62546 11.7437L9.64937 11.7439L9.69704 11.7436C9.72873 11.743 9.76026 11.7417 9.79157 11.7396L9.83836 11.736C9.8539 11.7346 9.86938 11.733 9.8848 11.7312L9.93084 11.7252C10.3586 11.664 10.73 11.4443 10.9159 10.9581L11.1412 10.34C11.2603 10.0127 11.2267 9.49345 11.145 9.04717L11.1317 8.97735C11.1272 8.95431 11.1225 8.9315 11.1177 8.90898L11.1031 8.84228L11.0956 8.80963L11.0802 8.74588C11.0725 8.71455 11.0645 8.68406 11.0565 8.65456L11.0404 8.59688L11.024 8.54204C11.0159 8.51537 11.0077 8.48984 10.9995 8.4656C10.7771 7.83795 10.7633 7.13212 11.0089 6.45746C11.5706 4.91409 13.2771 4.11832 14.8205 4.68006Z",
      "fill": "white"
    }
  })]), h("g", {
    "attrs": {
      "mask": 'url(#' + props.id + '05f87d2b' + ')'
    }
  })])]), h("defs", [h("filter", {
    "attrs": {
      "id": props.id + '9bc30c48',
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), h("feOffset", {
    "attrs": {
      "dy": "-0.75"
    }
  }), h("feComposite", {
    "attrs": {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in2": "shape",
      "result": "effect1_innerShadow_913_636"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '44be70f6',
      "x1": "-11.5521",
      "y1": "12.2832",
      "x2": "11.2225",
      "y2": "35.3873",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#FA781A"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#F2421B"
    }
  })])])]);
});